export const FLEX_DEALS_BATCH_SIZE = 50;
